'use strict';

import Vue from 'vue';
import _ from '_';

let CURRENT = null;

let defaults = {
	showCancel: true
	, cancelText: '取消'
	, buttons: []
	, themeClass: ''
};

let template = `
<div class="mask bottom" :class="themeClass" v-show="showStatus" style="z-index: 2147483647;" @click="hide">
	<div class="mask_content flex1 text-dark" style="padding-bottom:30px;">
		<a class="btn big white btn-radius margin30" style="display: block;" v-for="item in buttons" @click.stop="eventHook(item.text, item.fn)">
			<span class="text-dark fs18" v-text="item.text"></span>
		</a>

		<a class="btn big white btn-radius block marginh30 margint40" @click="hide">
			<span class="text-dark fs18" v-if="showCancel" v-text="cancelText"></span>		
		</a>
	</div>
</div>`;

let Actions = function(options){
	if( CURRENT ){
		CURRENT.$destroy( true );
	}

	let dom = document.createElement('div')
		, argc = arguments.length
		;

	if( typeof options === 'string' ){
		options = {
			buttons: [{
				text: options
				, fn : argc > 1 ? arguments[1] : null
			}]
		}
	}

	options = _.defaults(options, defaults);

	document.body.appendChild( dom );

	options.showStatus = true;

	CURRENT = new Vue({
		template
		, el: dom
		, data: options
		, methods: {
			hide(){
				this.showStatus = false;
				this.$destroy( true );
			}
			, cancel(){
				this.showStatus = false;

				options.cancelFn && options.cancelFn();

				this.$destroy( true );
			}
			, eventHook(text, fn){
				if( fn ){
					fn();
				}

				this.showStatus = false;
				this.$destroy( true );
			}
		}
	});
};

export default Actions;